import { createEndpoint } from '@/shared/models/api';
import { Informative } from '@/app/api/morgan-thermal';
import { MaterialInformation } from '@/app/api/morgan-thermal/material';

export const addFavoriteMaterial = createEndpoint<Informative>(({fetch}) => (id: MaterialInformation['id']) => fetch(`/Material/AddFavorite/${id}`, { method: 'POST' }));